import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  base: {
    position: 'absolute',
    left: 0,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center'
  },
  top: {
    top: 0
  },
  bottom: {
    bottom: 0
  }
});
